"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_checkbox_1 = require("@paypalcorp/pp-react-checkbox");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var addressErrors_1 = require("../../../utils/errorcodes/addressErrors");
var constants_1 = require("../../../constants");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var modalHeader_1 = require("../../../actions/modalHeader");
var interpolate_1 = require("../../../utils/interpolate/interpolate");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var constants_2 = require("./constants");
var update_address_view_1 = require("./update-address.view");
var update_billing_message_view_1 = require("./update-billing-message.view");
var route_utils_1 = require("../../../route.utils");
var page = require("page");
/**
 * Update billing address component
 * @author asebastian
 */
var UpdateBillingAddress = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateBillingAddress, _super);
    function UpdateBillingAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.isAddressChanged = function (addressToUpdate, formData) {
            return !_this.isAddressMatch(addressToUpdate, formData);
        };
        _this.isAddressMatch = function (addressToUpdate, formData) {
            var match = addressToUpdate.line1 === formData.line1 &&
                addressToUpdate.line2 === formData.line2 &&
                addressToUpdate.city === formData.city &&
                (addressToUpdate.state === formData.state ||
                    formData.state === "") &&
                addressToUpdate.postalCode === formData.postal_code;
            return match;
        };
        _this.markAddressPrimary = function () {
            var postData = {};
            postData[constants_2.ADDRESS.ADDRESS_ID_KEY] = _this.state.addressToUpdate.id;
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.ADDRESSES.MAKE_PRIMARY, postData, { component: { name: VIEWS.ADDRESSES.MAKE_PRIMARY } })
                .then(function (response) {
                var isFlow = _this.props.route.isFlow || false, flowName = _this.props.route.enter.flow || "", isBaseFlowInHistory = _this.props.route.history &&
                    _this.props.route.history.includes(ROUTES.ADDRESSES.FLOW_BASE);
                if (response && response.addresses) {
                    response.addresses = commonUtils_1.modifyObjectWithFactorById(response.addresses, _this.props.route.enter.params.id, VIEWS.ADDRESSES.TOAST_INTENTS.SET_PRIMARY, true);
                    _this.props.dispatchUpdateAddress(response);
                }
                if (window &&
                    window.venice &&
                    typeof window.venice.primaryAddressModified === "function") {
                    window.venice.primaryAddressModified();
                }
                _this.props.updateAction(VIEWS.ADDRESSES.TOAST_INTENTS.SET_PRIMARY);
                if (isFlow && !isBaseFlowInHistory) {
                    triggerOperationResult_1.triggerOperationResult(_this.props.addressFpti.billing
                        .updateBillingAddressAsPrimary, FPTI.SUCCESS, null);
                    route_utils_1.transitionOutHandler();
                    page(constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=" + constants_2.ADDRESS.FLOW_RETURN_VALUE.UPDATE_BILLING_ADDRESS_NON_PRIMARY_AS_PRIMARY);
                }
                else {
                    page.back();
                }
            })
                .catch(function (error) {
                var errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                _this.setState({
                    showSpinner: false,
                    errorMessage: errorContent,
                });
                triggerOperationResult_1.triggerOperationResult(_this.props.addressFpti.billing.setPrimaryOnly, FPTI.FAILURE, _this.props.content.common.genericSettingsError);
                return;
            });
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            if (_this.state.formIsValid || !_this.state.formChanged) {
                _this.setState({ showSpinner: true });
                var formData = {};
                for (var formElementIdentifier in _this.state.form) {
                    formData[formElementIdentifier] = _this.state.form[formElementIdentifier].value;
                }
                if (_this.isAddressChanged(_this.state.addressToUpdate, formData)) {
                    var postData = {};
                    postData[constants_2.ADDRESS.NEW_BILLING_ADDRESS_KEY] = formData;
                    postData[constants_2.ADDRESS.OLD_ADDRESS_ID_KEY] = _this.props.route.enter.params.id;
                    postData[constants_2.ADDRESS.CARD_IDS_KEY] = _this.state.addressToUpdate.cardList.map(function (card) { return card.id; });
                    postData[constants_2.ADDRESS.IS_OLD_ADDRESS_PRIMARY_KEY] = _this.state.addressToUpdate.primary;
                    postData[constants_2.ADDRESS.ADDRESS_IDS] = _this.props.addressData.addresses.map(function (address) { return address.id; });
                    ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.ADDRESSES.BILLING.EDIT, postData, { component: { name: VIEWS.ADDRESSES.BILLING.UPDATE } })
                        .then(function (addressInfo) {
                        var isFlow = _this.props.route.isFlow || false, flowName = _this.props.route.enter.flow || "", isBaseFlowInHistory = _this.props.route.history &&
                            _this.props.route.history.includes(ROUTES.ADDRESSES.FLOW_BASE);
                        var fptiValue = null, flowReturnValue = null;
                        if (addressInfo) {
                            _this.props.dispatchUpdateAddress(addressInfo);
                            var updateAction = void 0;
                            if (_this.state.addressToUpdate.primary) {
                                updateAction =
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .UPDATE_BILLING_PRIMARY;
                                fptiValue = _this.props.addressFpti.billing
                                    .updateBillingAddressPrimary;
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE
                                        .UPDATE_BILLING_ADDRESS_PRIMARY;
                            }
                            else if (_this.state.form.primary.value) {
                                updateAction =
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .UPDATE_BILLING_AS_PRIMARY;
                                fptiValue = _this.props.addressFpti.billing
                                    .updateBillingAddressAsPrimary;
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE
                                        .UPDATE_BILLING_ADDRESS_NON_PRIMARY_AS_PRIMARY;
                            }
                            else {
                                updateAction =
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .UPDATE_BILLING;
                                fptiValue = _this.props.addressFpti.billing
                                    .updateBillingAddress;
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE
                                        .UPDATE_BILLING_ADDRESS_NON_PRIMARY;
                            }
                            if (updateAction ===
                                VIEWS.ADDRESSES.TOAST_INTENTS
                                    .UPDATE_BILLING_PRIMARY ||
                                updateAction ===
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .UPDATE_BILLING_AS_PRIMARY) {
                                if (window &&
                                    window.venice &&
                                    typeof window.venice
                                        .primaryAddressModified === "function") {
                                    window.venice.primaryAddressModified();
                                }
                            }
                            _this.props.updateAction(updateAction);
                        }
                        if (addressInfo.ppcSynchronyDeeplinks &&
                            Object.keys(addressInfo.ppcSynchronyDeeplinks)
                                .length != 0) {
                            var ppcedit = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.EDIT_PPC;
                            page.redirect(ppcedit);
                        }
                        else {
                            if (isFlow && !isBaseFlowInHistory) {
                                triggerOperationResult_1.triggerOperationResult(fptiValue, FPTI.SUCCESS, null);
                                route_utils_1.transitionOutHandler();
                                page(constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=" + flowReturnValue);
                            }
                            else {
                                page.back();
                            }
                        }
                    })
                        .catch(function (error) {
                        var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "statusCode") || 500, errorDescFPTI, errorContent;
                        if (errorStatusCode >= 400 && errorStatusCode < 500) {
                            var code = addressErrors_1.errorCodes[error.errorKey];
                            errorContent = _this.props.content.addresses.error[code];
                        }
                        if (!errorContent) {
                            errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                        }
                        errorDescFPTI = errorContent;
                        _this.setState({
                            showSpinner: false,
                            errorMessage: errorContent,
                        });
                        triggerOperationResult_1.triggerOperationResult(_this.props.addressFpti.billing.update, FPTI.FAILURE, errorDescFPTI);
                        return;
                    });
                }
                else if (!_this.state.addressToUpdate.primary &&
                    _this.state.form.primary.value) {
                    _this.markAddressPrimary();
                }
                else {
                    var errorContent = _this.props.content.addresses.error[addressErrors_1.errorCodes.WALLET_SETTING_NO_CHANGE];
                    _this.setState({
                        errorMessage: errorContent,
                        showSpinner: false,
                    }, function () {
                        window.scroll({ top: 0, behavior: "smooth" });
                    });
                    return;
                }
            }
        };
        return _this;
    }
    UpdateBillingAddress.prototype.render = function () {
        var _this = this;
        var formElementsArray = [];
        var addressFpti = this.props.addressFpti, cardList = commonweb_utils_1.objectUtils.safeGet(this.state.addressToUpdate, "cardList") || [], isSingleCardAndItsUpdatable = cardList.length == 1 && cardList[0].isCardAddressUpdatable, properties = commonweb_utils_1.objectUtils.safeGet(this.props, "addressData.newAddress.entryMetadata.properties"), layout = commonweb_utils_1.objectUtils.safeGet(this.props, "addressData.newAddress.entryMetadata.layout"), addressInput = layout.map(function (lines) {
            return lines.map(function (addressKey) {
                return _this.inputElement(properties[addressKey], addressKey, _this.state.showSpinner);
            });
        });
        for (var key in this.state.form) {
            formElementsArray.push({
                id: key,
                config: this.state.form[key],
            });
        }
        var form = (React.createElement("form", { onSubmit: this.submitHandler },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, this.state.errorMessage)) : null,
            React.createElement(pp_react_1.Text, { className: "genericAccountHeader", size: "xl3" }, this.state.addressToUpdate.primary
                ? this.props.addressContent.editprimary.header
                : this.props.addressContent.edit.header),
            React.createElement("div", { className: "billing-cardlist" },
                React.createElement(pp_react_1.Text, { size: "md" }, interpolate_1.default("inHTMLData", this.props.addressContent.cards.one, {
                    numberOfCards: this.state.addressToUpdate
                        .cardList.length,
                })),
                commonUtils_1.cardsDetails(this.state.addressToUpdate.cardList)),
            addressInput,
            !this.state.addressToUpdate.primary ? (
            // @ts-ignore
            React.createElement(pp_react_checkbox_1.Checkbox, { className: "checkbox_space test_makeAddressPrimary", disabled: this.state.showSpinner, id: "primary", label: this.props.addressContent.addNewSetPrimary.checkBox, name: addressFpti.makePrimaryCheckbox, onChange: function (event) {
                    return _this.inputChangedHandler(event, "primary");
                } })) : null,
            React.createElement("div", { className: "removeBilling-info" },
                React.createElement(pp_react_1.Text, { size: "sm" }, this.props.addressContent.billing.updateIssuer)),
            React.createElement(pp_react_1.Button, { className: "fullWidth test_UpdateAddressButton", name: addressFpti.billing.submitUpdate, type: "submit", disabled: this.state.showSpinner }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: this.props.commonContent.loading, inverse: true })) : (this.props.commonContent.update))));
        var listPage = this.getListPage();
        return (React.createElement("div", null, this.state.addressToUpdate.cardList.length > 1 ||
            !isSingleCardAndItsUpdatable ? (React.createElement(update_billing_message_view_1.default, { isUpdate: true })) : (React.createElement("div", null, !this.state.openListPage ? form : listPage))));
    };
    return UpdateBillingAddress;
}(update_address_view_1.UpdateAddress));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti;
    var addressData = account.addressData, addressFpti = fpti.address, states = commonweb_utils_1.objectUtils.safeGet(addressData, "newAddress.entryMetadata.properties.state.list"), stateList = states ? states : [], addressContent = content.addresses, commonContent = content.common, showNavigation = account.showNavigation, updatedForm = addressData.updatedForm;
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        addressData: addressData,
        addressContent: addressContent,
        commonContent: commonContent,
        links: links,
        addressFpti: addressFpti,
        stateList: stateList,
        showNavigation: showNavigation,
        updatedForm: updatedForm,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchUpdateAddress: function (addressInfo) {
            return dispatch(addresses_1.buildAddress(addressInfo));
        },
        updateAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        changeHeaderVisibility: function (value) { return dispatch(modalHeader_1.showNavigation(value)); },
        updateForm: function (value) { return dispatch(addresses_1.updateForm(value)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdateBillingAddress);
